<button *ngIf="!isAnonymous" type="button" class="btn btn-secondary">
  <i class="fa-star favourite-icon mr-2" [ngClass]="isFavourite ? 'fas' : 'far'"></i>
  <span>{{ (isFavourite ? 'REMOVE_FROM_FAVORITE_LIST' : 'ADD_TO_FAVORITE_LIST') | translate }}</span>
</button>
